// Cost reports: every user's (`/api/admin/costs`, ViewAllCosts) and one task group's
// (`/api/task-groups/{id}/costs`). ocs-api's `CostQuery` lacks `parameter_in = Query`, so the spec
// puts `period` in the path and openapi-fetch would drop it; the URLs are written here, and the
// body is the spec's `CostReportDto`, unvalidated, as the generated client would return it.
import { queryOptions } from "@tanstack/react-query";

import { requestJson } from "../api/http";
import type { CostReport, Period } from "./model";

const get = async (path: string, period: Period) => (await requestJson("GET", `${path}?period=${period}`)) as CostReport;

export const adminCostsQuery = (period: Period) =>
  queryOptions({ queryKey: ["costs", "all", period], queryFn: () => get("/api/admin/costs", period) });

export const groupCostsQuery = (groupId: string, period: Period = "all") =>
  queryOptions({
    queryKey: ["costs", "group", groupId, period],
    queryFn: () => get(`/api/task-groups/${encodeURIComponent(groupId)}/costs`, period),
  });
